import { Alignment, dontForwardTheseProps, Spacing } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import type { BoxProps } from "@mui/material/Box";
import Box from "@mui/material/Box";
import type { IWithIsMobile } from "../../../interfaces/IWithIsMobile.interface";

const TITLE_MAX_WIDTH = "31.25rem";

const shouldForwardProp = dontForwardTheseProps<IWithIsMobile, BoxProps>(["isMobile"]);

export const HeaderV2TitleContainer = styled(Box, { shouldForwardProp })<IWithIsMobile>(({ isMobile }) => ({
  width: "100%",
  textAlign: isMobile ? Alignment.left : Alignment.center,
  marginLeft: isMobile ? Spacing["500"] : Spacing["0"],
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: TITLE_MAX_WIDTH,
  margin: "0 auto",
}));
